export type ProductionStatus = 'pending' | 'in_transit' | 'at_rest' | 'consumed'

const statusStyles: Record<ProductionStatus, string> = {
  pending: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200',
  in_transit: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
  at_rest: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
  consumed: 'bg-espresso-200 text-espresso-800',
}

const statusLabels: Record<ProductionStatus, string> = {
  pending: 'Pendiente',
  in_transit: 'En Tránsito',
  at_rest: 'En Almacén',
  consumed: 'Consumido',
}

export default function StatusBadge({ status, isActive }: { status: string; isActive?: boolean }) {
  if (isActive === false) {
    return (
      <span className="px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full whitespace-nowrap bg-cream-200 text-espresso-700">
        Anulado
      </span>
    )
  }
  const key = (status as ProductionStatus) in statusStyles ? (status as ProductionStatus) : null
  return (
    <span
      className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full whitespace-nowrap ${
        key ? statusStyles[key] : 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200'
      }`}
    >
      {key ? statusLabels[key] : status}
    </span>
  )
}
